<template>
    <access-denied v-if="accessDenied" title="regiao" />
    <div style="height: 100%" v-else>
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('regiao') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t($route.meta.contexto) }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('cadastros') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('regiao') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="!usuarioIntegracao && permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: `${$route.meta.abrev}-regiao-new` })"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-three-quarters">
                            <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-regiao" />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="regions"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete"
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        @click="confirmExclusion(props.row)"
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>
                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: `${$route.meta.abrev}-regiao-edit`,
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'criado-em'">
                                    {{ props.row[f.key] | moment('L') }}
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t('ativo') }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t('inativo') }}</b-tag
                                    >
                                </div>
                                <div v-else-if="f.key == 'codigo'">
                                    <pre>{{ props.row.idregiaoerp }}</pre>
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import RegiaoService from '@/services/RegiaoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes(`${this.abrev}-regiao`) && to.name != `${this.abrev}-regiao-list`) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('REGIAO'),
            regions: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new RegiaoService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: '10%', sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                {
                    key: 'criado-em',
                    width: 140,
                    sortable: true,
                    sortFn: this.sortCriadoEm,
                },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            searchQuery: '',
            deleteThis: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            empresas: [],
            accessDenied: false,
            permissao: null,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        if (this.$route.meta.abrev == 'ven') {
            this.abrev = this.$route.meta.contexto.slice(0, 3);
            this.permissao = this.hasPermissionAccess('vendas', 'clientes', 'ven-regiao');
        } else if (this.$route.meta.abrev == 'agro') {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'clientes', 'agro-regiao');
        } else if (this.$route.meta.abrev == 'pro') {
            this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'regioes');
        }

        this.rotaAninhada =
            this.$route.name.includes(`${this.$route.meta.abrev}-regiao`) &&
            this.$route.name != `${this.$route.meta.abrev}-regiao-list`;

        if (!this.permissao.read) {
            this.accessDenied = true;
        } else {
            this.loadEmpresas();
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    this.empresas, // @84479 - São passadas as empresas como parâmetro para a filtragem
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.searchQuery
                )
                .then(this.mapItems)
                .then((regions) => {
                    this.regions = regions;
                    this.isEmpty = this.regions.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    console.log('[REGIÕES] Erro ao carregar regiões.', e);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(situacao) {
            this.situacao = situacao;
            this.carregarDados();
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let regions = [];
            if (body.content) {
                regions = body.content.map((i) => {
                    return {
                        id: i.idregiao,
                        idregiaoerp: i.idregiaoerp,
                        descricao: i.descricao,
                        'criado-em': i.datahorainc,
                        excluir: 'excluir-regiao',
                        situacao: i.situacao,
                    };
                });
            }
            return regions;
        },
        onSearch(value) {
            this.searchQuery = this.removeAcentos(value);
            this.carregarDados();
        },
        confirmExclusion(item) {
            this.modalOpen = true;
            this.deleteThis = item;
            this.$root.confirm({
                message: this.$t(
                        item.situacao == 1
                            ? 'msg-confirmacao-desativacao-n'
                            : 'msg-confirmacao-reativacao-n', 
                        { n: item.descricao }
                    ),
                onConfirm: this.updateSituacaoRegistro,
                onCancel: (_) => {
                    this.deleteThis = null;
                },
            });
        },
        excluir() {
            let item = this.deleteThis;
            this.isLoading = true;
            this.service
                .delete(item.id)
                .then((_) => {
                    this.$root.showMessage('success', 'msg-success-excluir-regiao');
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-failure-excluir-regiao');
                    console.log(`[REGIÕES] Erro ao excluir região [ID ${item.id}]`, e);
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.deleteThis = null;
                });
        },
        parseDateString(d) {
            let a = d.split('T')[0].split('-');
            return new Date(a[0], a[1] - 1, a[2]).toLocaleDateString();
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        sortCriadoEm(a, b, isAsc) {
            let da = a['criado-em'].split('/').reverse().join('-');
            let db = b['criado-em'].split('/').reverse().join('-');
            if (isAsc) {
                return new Date(da).getTime() - new Date(db).getTime();
            } else {
                return new Date(db).getTime() - new Date(da).getTime();
            }
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.deleteThis.situacao == 1
                    ? 'erro-ao-desativar-regiao'
                    : 'erro-ao-reativar-regiao';

            let tempRegiao = {
                idregiao: this.deleteThis.id,
                situacao: this.deleteThis.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempRegiao)
                .then((r) => {
                    if (r.status == 200) {
                        if (r.content.situacao == 1) {
                            this.$root.showMessage('success', 'msg-sucesso-ao-reativar-regiao');
                        } else if (r.content.situacao == 0) {
                            this.$root.showMessage('success', 'msg-sucesso-ao-desativar-regiao');
                        }
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        // @84479 - Método que verifica se o usuário é administrador. Caso seja, lhe são atribuídas todas as empresas disponíveis.
        //          Caso não seja admin, são atribúidas as empresas que o usuário tem associação.
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                /* objeto window.empresas */
                return this.$store.state.empresas.disponivel
                    ? this.$store.state.empresas.data.map((e) => {
                          this.empresas.push(e.idempresa);
                      })
                    : [];
            } else {
                return this.$store.state.user.empresas.map((e) => {
                    this.empresas.push(e.idempresa);
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 15px 15px 21px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .situacao-select div {
            height: 40px;
        }
    }
}
</style>
